export const REF_NAME = 'PAYMENTMETHOD';
export const REF_PATH = 'paymentmethod';
export const NAME = 'Payment method';
